
import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, } from '@material-ui/core';
import MPage from '../view/MPage';
import MatchLeagueHeader from './MatchLeagueHeader';
import { MatchLeagueContentDay, MatchLeagueContentHot, MatchLeagueContentArea } from './view';
import Apis from '../../network/Apis';
import AppData from '../../model/AppData';
import AppUtils from '../../control/apputlis';

const ICON = require("../../images/icons/shaixuan.png");

class MatchLeague extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dayData: [],
            hotData: [],
            areaData: [],
            value: 0,
        };

        console.log('MatchLeague', props);
    }

    _handleChange(val) {
        this.setState({ value: val, dayData: [], hotData: [], areaData: [] }, () => {
            this.getLeagueList();
        });
    }

    componentDidMount() {
        this.getLeagueList();
        AppUtils.YMPush('MAIN', 'MatchLeague');
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    getLeagueList = async () => {
        let data = AppData.getSchedusMatchData(this.state.value + 1);
        let dayData = [];
        if (data && data.length > 0) {
            dayData = data;
        } else {
            let result = await Apis.encryptionMatch(this.state.value + 1);
            if (result.code == 200) {
                dayData = result.data;
            }
        }
        let hotData = await Apis.encryptionLeagueList(this.state.value + 1);
        let areaData = await Apis.encryptionAddress(this.state.value + 1);


        let ddata = [];
        for (let i = 0; i < dayData.length; i++) {
            let isExast = false;
            ddata.forEach(item => {
                if (item.short_name_zh == dayData[i].short_name_zh) {
                    isExast = true;
                    item.match_num++;
                }
            });
            if (!isExast) {
                dayData[i].match_num = 1;
                ddata.push(dayData[i]);
            }
        }
        this.state.dayData = ddata;

        if (hotData.code == 200) {
            let data = [];
            for (let i = 0; i < hotData.data.length; i++) {
                data.push({
                    competition_id: hotData.data[i].id,
                    short_name_zh: hotData.data[i].name,
                    type_id: this.state.value + 1,
                    logo: hotData.data[i].logo,
                    name: hotData.data[i].name,
                });
            }
            this.state.hotData = data;
        }
        if (areaData.code == 200) {
            this.state.areaData = areaData.data;
        }
        console.log("hotData====>", this.state.hotData);
        this.setState({ dayData: this.state.dayData, hotData: this.state.hotData, areaData: this.state.areaData });
    }


    render() {
        const { classes } = this.props;
        const { dayData, hotData, areaData, value } = this.state;
        return (
            <MPage Header={<MatchLeagueHeader onChange={(val) => this._handleChange(val)} />}>
                <MatchLeagueContentDay title={'今日赛事'} data={dayData} ></MatchLeagueContentDay>
                <MatchLeagueContentHot title={'热门赛事'} data={hotData} typeId={value + 1} ></MatchLeagueContentHot>
                <MatchLeagueContentArea title={'地区赛事'} data={areaData} typeId={value + 1} ></MatchLeagueContentArea>
            </MPage>
        );
    }

}

export default withRouter(withStyles((theme) => ({
    root: {
        backgroundSize: 'cover',
        width: '100vw',
        height: '100vh',
        display: "flex",
        backgroundColor: theme.palette.background.default,
        flexDirection: "column",
        alignItems: 'center',
    },
    subheader: {
        width: '100%',
        padding: theme.spacing(0, 0, 0, 0),
        backgroundColor: theme.palette.background.default,
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
}))(MatchLeague));